<template>
  <fieldset class="step step--3">
    <Section :title="stepTitle">
      <CertificationFormGroup name="range">
        <RadioControl
          id="range-type"
          v-model="form.range"
          :options="rangeType"
          number="1"
          :get-object="false"
          label="Zasięg geograficzny wydarzenia"
          :disabled="formDisabled"
          @input="setRangeType($event)"
        />
      </CertificationFormGroup>

      <CertificationFormGroup
        v-if="form.range == 'regional'"
        name="rangeLocation"
      >
        <template slot-scope="{ validator }">
          <SelectControl
            id="range-location-regional"
            v-model="form.rangeLocation"
            :options="voivodeshipType"
            number="1a"
            :get-object="false"
            :multiple="true"
            :block-tag="true"
            label="Z jakich województw pochodzą uczestnicy?"
            :disabled="formDisabled"
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup>
      <CertificationFormGroup
        v-if="form.range == 'voivodeship'"
        name="rangeLocation"
      >
        <template slot-scope="{ validator }">
          <SelectControl
            id="range-location-voivodeship"
            v-model="form.rangeLocation"
            :options="voivodeshipType"
            number="1a"
            :get-object="false"
            label="Z jakiego województwa pochodzą uczestnicy?"
            :disabled="formDisabled"
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup>
      <CertificationFormGroup v-if="form.range == 'local'" name="rangeLocation">
        <InputControl
          id="range-location-local"
          v-model="form.rangeLocation"
          :options="voivodeshipType"
          number="1a"
          :get-object="false"
          label="Z jakiego miasta (i jego okolic) pochodzą uczestnicy wydarzenia"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="q_3_2">
        <TrueFalseControl
          id="q_3_2"
          v-model="form.q_3_2"
          number="2"
          label="Wydarzenie odbywa się w lokalizacji będącej siedzibą organizatora merytorycznego"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="q_3_3">
        <TrueFalseControl
          id="q_3_3"
          v-model="form.q_3_3"
          number="3"
          label="Wydarzenie odbywa się w jednym obiekcie"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>

      <transition name="slide-fade">
        <div v-show="form.q_3_3 !== null">
          <CustomControl
            v-if="form.q_3_3 === true"
            id="locations"
            label="Lokalizacja i obiekt"
            number="3a"
            :disabled="formDisabled"
          />
          <CustomControl
            v-if="form.q_3_3 === false"
            id="locations"
            label="Lokalizacje i obiekty"
            number="3a"
            :disabled="formDisabled"
          />

          <alert
            v-if="v.step3['form.locations'].minLocationsLength === false"
            variant="danger"
            show
          >
            Proszę wymienić wszystkie lokalizacje (min. 2).
          </alert>

          <CertificationFormLocations
            id="locations"
            v-model="form.locations"
            :form-date="form.date[0]"
            :single="form.q_3_3"
            :disabled="formDisabled"
          />
        </div>
      </transition>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import SelectControl from "@/components/Controls/SelectControl";
import InputControl from "@/components/Controls/InputControl";
import CustomControl from "@/components/Controls/CustomControl";
import TrueFalseControl from "@/components/Controls/TrueFalseControl";
import RadioControl from "@/components/Controls/RadioControl";
import { rangeType, voivodeshipType } from "./data";
import CertificationFormLocations from "./CertificationFormLocations";

export default {
  name: "CertificationFormStep3",
  components: {
    CustomControl,
    RadioControl,
    SelectControl,
    InputControl,
    TrueFalseControl,
    CertificationFormLocations
  },
  extends: BaseCertificationFormStep,
  data() {
    return {
      rangeType,
      voivodeshipType
    };
  },
  watch: {
    "form.range": function(newValue, oldValue) {
      if (newValue != oldValue && oldValue != null) {
        this.form.rangeLocation = newValue === "regional" ? [] : "";
      }
    }
  },
  methods: {
    setRangeType(e) {}
  }
};
</script>
